module.exports = __webpack_public_path__ + "img/headingEle.637e55d1.svg";